import { render, staticRenderFns } from "./settingButton.vue?vue&type=template&id=2289aefe&"
import script from "./settingButton.vue?vue&type=script&lang=ts&"
export * from "./settingButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports